/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLists.defs.js'
export * as $defs from './getLists.defs.js'
